import React from 'react';

const PersonIconHeader = ({
  size = 20,
  fill = '#4F4C4D',
}: {
  size?: number | string;
  fill?: string;
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99998 9.74356C9.19791 9.74356 8.51128 9.45798 7.9401 8.88681C7.36892 8.31563 7.08333 7.62901 7.08333 6.82694C7.08333 6.02485 7.36892 5.33823 7.9401 4.76706C8.51128 4.19588 9.19791 3.91029 9.99998 3.91029C10.802 3.91029 11.4887 4.19588 12.0599 4.76706C12.631 5.33823 12.9166 6.02485 12.9166 6.82694C12.9166 7.62901 12.631 8.31563 12.0599 8.88681C11.4887 9.45798 10.802 9.74356 9.99998 9.74356ZM3.75 16.0897V14.2372C3.75 13.8291 3.86085 13.4511 4.08254 13.1034C4.30422 12.7556 4.60042 12.4883 4.97115 12.3013C5.79487 11.8974 6.6258 11.5946 7.46394 11.3926C8.30208 11.1907 9.14742 11.0898 9.99998 11.0898C10.8525 11.0898 11.6979 11.1907 12.536 11.3926C13.3742 11.5946 14.2051 11.8974 15.0288 12.3013C15.3995 12.4883 15.6957 12.7556 15.9174 13.1034C16.1391 13.4511 16.25 13.8291 16.25 14.2372V16.0897H3.75ZM4.99998 14.8397H15V14.2372C15 14.0684 14.9511 13.9121 14.8533 13.7684C14.7556 13.6247 14.6228 13.5075 14.4551 13.4166C13.7372 13.063 13.0051 12.7951 12.2589 12.613C11.5127 12.4308 10.7597 12.3397 9.99998 12.3397C9.24023 12.3397 8.48726 12.4308 7.74106 12.613C6.99487 12.7951 6.2628 13.063 5.54485 13.4166C5.37712 13.5075 5.24437 13.6247 5.14662 13.7684C5.04886 13.9121 4.99998 14.0684 4.99998 14.2372V14.8397ZM9.99998 8.4936C10.4583 8.4936 10.8507 8.33041 11.1771 8.00402C11.5035 7.67763 11.6666 7.28527 11.6666 6.82694C11.6666 6.3686 11.5035 5.97624 11.1771 5.64985C10.8507 5.32346 10.4583 5.16027 9.99998 5.16027C9.54165 5.16027 9.14928 5.32346 8.8229 5.64985C8.49651 5.97624 8.33331 6.3686 8.33331 6.82694C8.33331 7.28527 8.49651 7.67763 8.8229 8.00402C9.14928 8.33041 9.54165 8.4936 9.99998 8.4936Z"
        fill={fill}
      />
    </svg>
  );
};

export default PersonIconHeader;
